<div class="not-found">404</div>
<div class="message">
  <h1>{{ 'NOT_FOUND_PAGE.HEADER' | translate }}</h1>
  <p>{{ 'NOT_FOUND_PAGE.DESCRIPTION' | translate }}</p>
  <span
    class="link"
    [routerLink]="['/']"
    >{{ 'NOT_FOUND_PAGE.RETURN_HOME' | translate }}</span
  >
</div>
